import { useMutation } from "@apollo/client";

import {
  DeleteAnnotationInput,
  DeleteAnnotationMutation,
  DeleteAnnotationMutationVariables,
} from "../../../API";
import { DELETE_ANNOTATION } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";
import { Reference } from "@apollo/client";

export const useDeleteAnnotation = () => {
  const [deleteAnnotationMutation, { data, loading }] = useMutation<
    DeleteAnnotationMutation,
    DeleteAnnotationMutationVariables
  >(DELETE_ANNOTATION);

  const deleteAnnotation = async ({
    zoneId,
    serviceId,
    id,
  }: DeleteAnnotationInput) => {
    return await deleteAnnotationMutation({
      variables: {
        input: { zoneId, serviceId, id },
      },
      update: (cache, { data }) => {
        if (data?.deleteAnnotation) {
          cache.modify({
            fields: {
              getAnnotations(existing = { items: [] }, { readField }) {
                const filteredItems = existing.items.filter(
                  (ref: Reference) => {
                    const refId = readField("id", ref);

                    return refId !== data?.deleteAnnotation?.id;
                  }
                );

                return {
                  ...existing,
                  items: filteredItems,
                };
              },
            },
          });
        }
      },
      onError: handleApolloError,
      refetchQueries: ["GetAnnotations"],
    });
  };

  return { deleteAnnotation, data, loading };
};
